export enum WorkflowRequestTypes {
    None = 'None',
    ApplicationCreate = 'ApplicationCreate',
    ApplicationUpdate = 'ApplicationUpdate',
    ApplicationNewClientSecret = 'ApplicationNewClientSecret',
    ApplicationDeleteClientSecret = 'ApplicationDeleteClientSecret',
    ApplicationPermissionChange = 'ApplicationPermissionChange',
    ApplicationPermissionGrant = 'ApplicationPermissionGrant',
    ApplicationPermissionRevoke = 'ApplicationPermissionRevoke',
    ApplicationRoleGrant = 'ApplicationRoleGrant',
    GroupMembershipUpdate = 'GroupMembershipUpdate',
    GroupCreate = 'GroupCreate',
    GroupUpdate = 'GroupUpdate',
    SecretCreate = 'SecretCreate',
    SecretDelete = 'SecretDelete',
    GuestDelete = 'GuestDelete',
    GuestCreate = 'GuestCreate',
    GuestUpdate = 'GuestUpdate',
    SecretUpdatePermissions = 'SecretUpdatePermissions',
    AccountUnlock = 'AccountUnlock',
    ServiceAccountUpdate = 'ServiceAccountUpdate',
    ServiceAccountDelete = 'ServiceAccountDelete',
    ServiceAccountDisable = 'ServiceAccountDisable',
    PrivilegeAccountDelete = 'PrivilegeAccountDelete',
    CocoUserCreate = 'CocoUserCreate',
    CocoUserUpdate = 'CocoUserUpdate',
    CocoUserDelete = 'CocoUserDelete',
    MfaReset = 'MfaReset',
    PrivilegeAccountCreate = 'PrivilegeAccountCreate',
    ServiceAccountCreate = 'ServiceAccountCreate',
    MailboxAccountCreate = 'MailboxAccountCreate',
    CyberEventCompromisedSourcingCompanyCreate = 'CyberEventCompromisedSourcingCompanyCreate',
    CyberEventCompromisedSourcingCompanyClose = 'CyberEventCompromisedSourcingCompanyClose',
    ApplicationNonChevronPermissionsUpdate = 'ApplicationNonChevronPermissionsUpdate',
    SecretUserEnable = 'SecretUserEnable',
    ServiceAccountDeferment = 'ServiceAccountDeferment',
    Tier0AttestationEscalation = 'Tier0AttestationEscalation'
}   